module.exports = "<div class=about-pane> <div class=modal-header> <h1 class=overlay-title>API Design First Workflow</h1> <h3>Easily create API specifications</h3> </div> <div class=file-arrow></div> <div class=sample>Try a sample here</div> <button id=dismis-intro class=\"btn btn-warning btn-close\" ng-click=toggleAboutEditor(false)> </button> <div class=yaml-author>Write API specs in YAML...</div> <div class=sw-preview>...Preview documentation in Swagger</div> <button class=\"btn btn-warning btn-intro\" ng-click=toggleAboutEditor(false)>Got it!</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./templates/intro.html
// module id = 568
// module chunks = 0